// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2X1Cy","content":"styles_content__266bs","row":"styles_row__2CIpO","footer":"styles_footer__2WCXg","phraseLength":"styles_phraseLength__2ZErF"};